"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.add = add;
exports.default = void 0;
exports.del = del;
exports.edit = edit;
exports.getAllJob = getAllJob;

var _request = _interopRequireDefault(require("@/utils/request"));

function getAllJob() {
  var params = {
    page: 0,
    size: 9999,
    enabled: true
  };
  return (0, _request.default)({
    url: 'api/job',
    method: 'get',
    params: params
  });
}

function add(data) {
  return (0, _request.default)({
    url: 'api/job',
    method: 'post',
    data: data
  });
}

function del(ids) {
  return (0, _request.default)({
    url: 'api/job',
    method: 'delete',
    data: ids
  });
}

function edit(data) {
  return (0, _request.default)({
    url: 'api/job',
    method: 'put',
    data: data
  });
}

var _default = {
  add: add,
  edit: edit,
  del: del
};
exports.default = _default;